import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const MinusIcon: FC<SvgProps> = (props) => {
    return (
        <Svg viewBox="0 0 24 24" {...props}>
            <Path d="M6 13a.967.967 0 0 1-.713-.287A.968.968 0 0 1 5 12c0-.283.096-.52.287-.713A.967.967 0 0 1 6 11h12c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 18 13H6Z" />
        </Svg>
    )
}

export default MinusIcon
